import { styled } from '@mui/material/styles';

export const SsContainer = styled('div')({
  position: 'relative',
  marginBottom: 200,

  '@media print': {
    pageBreakInside: 'avoid',
    pageBreakAfter: 'always !important',
    marginBottom: 0,
  },
});

export const ScorecardWrap = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),

  '@media print': {
    pageBreakInside: 'avoid',
  },
}));

export const ScoreRowDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: 20,
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: theme.spacing(1),
}));

export const ScoreBox = styled('div')(({ theme }) => ({
  height: 20,
  border: `1px solid ${theme.palette.divider}`,
  width: '100%',
  margin: 10,
  position: 'relative',
}));

export const BoxBg = styled('div')({
  position: 'absolute',
  left: 2,
  top: 2,
  bottom: 2,
});

export const TargetBar = styled('div')({
  position: 'absolute',
  top: 2,
  bottom: 2,
  zIndex: 1,
});

export const BlackBar = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: 2,
  top: -2,
  bottom: -2,
  backgroundColor: theme.palette.common.black,
  zIndex: 2,
}));

export const ScoreTitleDiv = styled('div')({
  width: 300,
  textAlign: 'right',
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const ScoreValueDiv = styled('div')({
  width: 300,
  textAlign: 'left',
});

export const TargetDiffSpan = styled('span')({
  marginLeft: 8,
  fontSize: 12,
});
